import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

export type ChoiceModalParams = {
  icon?: string;
  level: ModalLevel;
  page: ModalPage;
  text?: string;
  title: string;
  choice1Text: string;
  choice2Text: string;
  choice1ThemeColor: string;
  choice2ThemeColor: string;
}

type ModalLevel = 'normal' | 'warning' | 'danger';

type ModalPage = 'readings' | 'charts' | 'alerts' | 'reports';

@Component({
    selector: 'app-choice-dialog-modal',
    templateUrl: './choice-dialog-modal.component.html',
    styleUrls: ['./choice-dialog-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChoiceDialogModalComponent {

  @Input()
  title: string;

  @Input()
  text: string;

  @Input()
  choice1Text: string;

  @Input()
  choice2Text: string;

  @Input()
  icon: string;

  @Input() choice1ThemeColor: string;
  @Input() choice2ThemeColor: string;

  @Input()
  level: ModalLevel;

  @Input()
  page: ModalPage;

  constructor (public modal: NgbActiveModal) {
  }
}
